export default __webpack_public_path__ + "static/media/kweak_s.fd1b4c71.jpg";